import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

/** 1. GET cost centres eligible for a depreciation value — Otype 'Add' = not yet configured, anything else = already configured */
export const getCCForDepreciation = (Otype) =>
    axios.get(`${base}/Accounts/GetCCForODAccrued`, { params: { Otype } });

/** 2. GET the earliest allowed WEF date for a new depreciation percentage entry (day after the last one on file) */
export const getDepreciationWefDate = () =>
    axios.get(`${base}/Accounts/Getwefdate`);

/** 3. GET the currently configured depreciation value for a cost centre */
export const getCCDepreciationValue = (CCCvalue) =>
    axios.get(`${base}/Accounts/GetCCValue`, { params: { CCCvalue } });

/** 4. GET the combined grid — per-CC values and percentage-history rows, distinguished by ReportType */
export const getDepreciationConfigGrid = () =>
    axios.get(`${base}/Accounts/DepriciationConfigGrid`);

/** 5. POST save either a per-CC depreciation value (Action: 'Depvalue') or a new WEF-dated percentage (Action: 'Deppercent') */
export const saveCCDepValues = (payload) =>
    axios.post(`${base}/Accounts/SaveCCDepValues`, payload);
